"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _ColorPreview = _interopRequireDefault(require("../ColorPreview"));
var _locale = require("../locale");
var _constants = require("../utils/constants");
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _TokenInput = _interopRequireDefault(require("./TokenInput"));
var Link = _antd.Typography.Link;
var useStyle = (0, _makeStyle.default)('ComponentTokenEditorTokenItem', function (token) {
  return (0, _defineProperty2.default)({}, token.componentCls, (0, _defineProperty2.default)({
    borderRadius: token.borderRadiusLG,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    transition: 'all 0.2s',
    gap: 4
  }, "".concat(token.componentCls), {
    '&:not(:last-child)': {
      marginBottom: 4
    },
    '&-name': {
      fontSize: token.fontSizeSM,
      color: token.colorText
    },
    '&-prefix': {
      flex: 'none'
    },
    '&-tag': {
      fontSize: token.fontSizeSM,
      lineHeight: token.lineHeightSM,
      background: token.colorSuccessBg,
      color: token.colorSuccess,
      padding: '0 6px',
      borderRadius: token.borderRadiusSM
    },
    '&-value': {
      fontSize: token.fontSizeSM,
      lineHeight: token.lineHeightSM,
      marginLeft: 'auto',
      maxWidth: 140,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      background: token.colorFillQuaternary,
      color: token.colorTextTertiary,
      padding: '0 6px',
      borderRadius: token.borderRadiusSM,
      flex: '0 1 auto'
    },
    '&-operator': {
      marginLeft: 'auto',
      borderRadius: token.borderRadiusLG,
      padding: '0 8px',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      flex: '0 0 0%',
      width: '100%',
      '&:hover': {
        background: token.colorFillQuaternary
      }
    }
  }));
});
var TokenItem = function TokenItem(_ref2) {
  var token = _ref2.token,
    prefix = _ref2.prefix,
    value = _ref2.value,
    theme = _ref2.theme,
    component = _ref2.component,
    color = _ref2.color,
    tooltip = _ref2.tooltip,
    configValue = _ref2.configValue;
  var prefixCls = "antd-component-token-editor-token-item";
  var locale = (0, _locale.useLocale)();
  var _useStyle = useStyle(prefixCls),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    hashId = _useStyle2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(prefixCls, hashId),
    key: token
  }, prefix && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-prefix")
  }, prefix), /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: tooltip,
    mouseEnterDelay: 0.5,
    placement: "left"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-name"),
    style: {
      color: configValue !== undefined ? _constants.HIGHLIGHT_COLOR : ''
    }
  }, token)), configValue !== undefined && /*#__PURE__*/_react.default.createElement(Link, {
    style: {
      fontSize: 12,
      margin: '0 4px',
      flex: 'none'
    },
    onClick: function onClick(e) {
      var _theme$onAbort;
      e.stopPropagation();
      (_theme$onAbort = theme.onAbort) === null || _theme$onAbort === void 0 || _theme$onAbort.call(theme, ['components', component, token]);
    }
  }, locale.reset), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      width: 0,
      display: 'flex',
      justifyContent: 'flex-end',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_TokenInput.default, {
    theme: theme,
    token: token,
    component: component,
    color: !!color,
    value: value,
    className: "".concat(prefixCls, "-operator")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-value"),
    title: value
  }, String(value)), color && /*#__PURE__*/_react.default.createElement(_ColorPreview.default, {
    size: 16,
    color: value,
    style: {
      marginLeft: 8,
      flex: 'none'
    }
  }))));
};
var _default = exports.default = TokenItem;